/* eslint-disable max-lines */
/* eslint-disable max-len */

export function ContentLocaleSv() {
  return (
    <>
      <div>
        <p className="page-title">
          Dataskyddspolicy för Professional-kontoportalen
        </p>
        <h2 className="heading-title">
          I. Namn och adress till den personuppgiftsansvariga och
          dataskyddsombudet
        </h2>

        <p className="my-20">
          Den personuppgiftsansvariges namn och kontaktuppgifter:
        </p>
        <p>Kärcher AB</p>
        <p>Mikael Rasmusson, VD</p>
        <p>Tagenevägen 31</p>
        <p>425 02 Hisings Kärra</p>
        <p>031-577 300</p>
        <p>
          <a href="mailto:mikael.rasmusson@karcher.se">
            mikael.rasmusson@karcher.se
          </a>
        </p>

        <p className="my-10">
          (härefter: Kärcher) ska rätta sig efter lagstadgade bestämmelser
          såvitt avser all databehandling (t.ex. insamling, behandling och
          överföring).
        </p>

        <p className="my-10">
          Följande policy ger dig en översikt över vilka typer av data som
          samlas in på och via vår Professional-kontoportal på
          account.kaercher.com (härefter: plattformen), hur de behandlas, vilka
          säkerhetsåtgärder Kärcher vidtar för att skydda dina uppgifter och hur
          du utövar dina rättigheter.
        </p>

        <p className="my-10">
          För frågor om dataskydd och om dina rättigheter som registrerad,
          vänligen kontakta Kärchers dataskyddsombud på:
        </p>

        <p>Kärcher AB</p>
        <p>Johan Widepalm</p>
        <p>Tagenevägen 31</p>
        <p>425 02 Hisings Kärra</p>
        <p>
          <a href="mailto:Johan.widepalm@karcher.com">
            Johan.widepalm@karcher.com
          </a>
        </p>
      </div>

      <div className="mt-40">
        <h2>II. Allmän information om databehandling</h2>

        <h3>1. Omfattningen av behandlingen av personuppgifter</h3>
        <p>
          Om inget annat anges behandlar vi dina personuppgifter som användare
          av vår plattform (härefter: registrerad) för att ge dig en Kärcher
          Professional-användare med vilken som du kan registrera dig med olika
          portaler för det professionella området. Vi behandlar följande
          personuppgifter för registrering av en Kärcher Professional-användare:
        </p>

        <ul>
          <li>Typ av adress</li>
          <li>Namn</li>
          <li>E-post för företag</li>
        </ul>
        <p>
          En Kärcher Professional-användare måste skapas för att kunna använda
          det skyddade området. Användning av innehållet som skyddas av
          registreringsbegäran (inloggningsområde) är inte möjligt utan att ange
          personuppgifter. Om du vill använda vårt inloggningsområde måste du
          fylla i de uppgifter som anges som obligatoriska och skapa ett
          användarkonto.
        </p>

        <h3>2. Rättslig grund för behandling av personuppgifter</h3>
        <p>
          Om behandlingen av personuppgifter krävs för användning av
          plattformen, fungerar art. 6 (1) (b) GDPR som rättslig grund. Detta
          gäller även behandlingar som är nödvändiga för att genomföra åtgärder
          som föregår ett avtal.
        </p>

        <p className="mt-10">
          I den mån vi erhåller den registrerades samtycke för behandling av
          personuppgifter, fungerar art. 6 (1) (a) i den allmänna
          dataskyddsförordningen (GDPR) som rättslig grund.
        </p>

        <p className="mt-10">
          I den mån behandlingen av personuppgifter är nödvändig för att
          uppfylla en rättslig skyldighet som vårt företag är föremål för,
          fungerar art. 6 (1) (c) GDPR som rättslig grund.
        </p>

        <p className="mt-10">
          Om behandlingen är nödvändig för att tillvarata ett legitimt intresse
          för vårt företag eller en tredje part, och om den registrerades
          intressen, grundläggande rättigheter och friheter inte väger tyngre än
          det ovan nämnda intresset, utgör art. 6 (1) (f) GDPR som rättslig
          grund för sådan behandling.
        </p>

        <h3>3. Syftet med databehandlingen</h3>
        <p>
          Registrering av ett Kärcher Professional-konto möjliggör eller
          förenklar användningen av funktioner som tillhandahålls, t.ex.
          Robotics-portalen och myKärcher Business. För att du lättare ska kunna
          använda dessa funktioner behandlar vi registrerings- och
          inloggningsuppgifterna för Kärcher Professional-kontot som du har
          angett hos oss eller som du har fått.
        </p>

        <h3>4. Lagringens varaktighet</h3>
        <p>
          När du skapar ett Kärcher Professional-konto lagrar vi vanligtvis dina
          uppgifter så länge du behåller ditt konto.
        </p>

        <h3>5. Möjlighet till radering</h3>
        <p>
          Som användare av ett Kärcher Professional-konto har du möjlighet att
          när som helst radera kontot och de data som lagrats med det.
        </p>
      </div>

      <div className="mt-40">
        <h2>III. Tillhandahållande av plattformen</h2>

        <h3>1. Beskrivning och omfattning av databehandlingen</h3>
        <p>
          Varje gång du går in på vår plattform samlar vårt system automatiskt
          in data och information från det datorsystemet varifrån åtkomst sker.
        </p>

        <p className="mt-10">Följande uppgifter samlas in i detta avseende:</p>

        <ul>
          <li>Datum och tidpunkt för förfrågan</li>
          <li>Tid för den senaste inloggningen/beställningen</li>
          <li>Sida som filen begärts från</li>
          <li>
            Åtkomststatus (fil överförd, filen hittades inte och så vidare)
          </li>
          <li>Webbläsare och operativsystem som används</li>
          <li>Fullständig IP-adress för den begärande datorn</li>
          <li>Överförd datavolym</li>
          <li>Begärans storlek</li>
        </ul>

        <p>Uppgifterna lagras även i vårt systems loggfiler.</p>

        <h3>2. Rättslig grund för databehandling</h3>
        <p>
          Den rättsliga grunden för tillfällig lagring av data och loggfiler är
          art. 6 (1) (f) GDPR.
        </p>

        <h3>3. Syftet med databehandlingen</h3>
        <p>
          Systemets tillfälliga lagring av IP-adressen är nödvändig för att
          tillhandahålla plattformen till användarens dator. För detta ändamål
          måste användarens IP-adress förbli lagrad under sessionen.
        </p>

        <p className="mt-10">
          Lagring i loggfiler sker för att säkerställa plattformens
          funktionalitet. Dessutom använder vi uppgifterna för att optimera
          plattformen och för att säkerställa säkerheten i våra IT-system.
        </p>

        <p className="mt-10">
          Dessa ändamål utgör också vårt berättigade intresse av databehandling
          enligt art. 6 (1) (f) GDPR.
        </p>

        <h3>4. Lagringens varaktighet</h3>
        <p>
          Uppgifterna raderas så snart de inte längre behövs för att uppnå det
          syfte för vilket de samlades in.
        </p>
      </div>

      <div className="mt-40">
        <h2>IV. Användning av cookies</h2>

        <h3>1. Beskrivning och omfattning av databehandlingen</h3>
        <p>
          Vår plattform använder cookies. Cookies är textfiler som lagras i
          webbläsaren eller av webbläsaren på användarens dator. När en
          användare öppnar en plattform kan en cookie lagras i användarens
          operativsystem. Denna cookie innehåller en karakteristisk teckensträng
          som gör att webbläsaren kan identifieras unikt när plattformen anropas
          igen.
        </p>

        <p className="mt-10">
          Vi använder endast funktionella eller tekniskt nödvändiga cookies för
          att kunna erbjuda vår plattform.
        </p>

        <h3>2. Rättslig grund för databehandling</h3>
        <p>
          Rättslig grund för behandling av personuppgifter med hjälp av tekniskt
          nödvändiga cookies är art. 6 (1) (f) GDPR.
        </p>

        <h3>3. Syftet med databehandlingen</h3>
        <p>
          Syftet med användningen av tekniskt nödvändiga cookies är att
          säkerställa att plattformen och de tjänster som ingår i den fungerar
          fullt ut för användarna. Vissa funktioner på vår plattform kan inte
          erbjudas utan användning av cookies. Användardata som samlas in av
          tekniskt nödvändiga cookies används inte för att skapa
          användarprofiler. Dessa ändamål utgör också vårt berättigade intresse
          av behandling av personuppgifter enligt art. 6 (1) (f) GDPR.
        </p>

        <h3>4. Möjlighet till invändning</h3>
        <p>
          Cookies lagras på användarens dator och överförs därifrån till vår
          webbplats. Som användare har du därför full kontroll över användningen
          av cookies. Du kan avaktivera eller begränsa överföringen av cookies
          genom att ändra inställningarna i din webbläsare. Cookies som redan
          har sparats kan när som helst raderas. Detta kan också automatiseras.
          Om cookies för vår plattform är avaktiverade går det eventuellt inte
          längre att använda plattformens alla funktioner fullt ut.
        </p>
      </div>

      <div className="mt-40">
        <h2>V. Utlämnande till tredje part</h2>

        <p className="mt-10">
          Inom Kärcher-koncernen utbyter vi personuppgifter inom koncernen i den
          mån och i den utsträckning det är nödvändigt för behandling av avtal
          eller för genomförande av åtgärder före avtal i enlighet med art. 6
          (1) (b) GDPR eller om det finns ett berättigat intresse av en
          koncernintern överföring i enlighet med art. 6 (1) (f) GDPR.
        </p>

        <p className="mt-10">
          Utöver de fall som uttryckligen nämns i denna dataskyddspolicy
          vidarebefordras dina personuppgifter till tredje part utan ditt
          uttryckliga förhandsgodkännande endast om detta är lagenligt eller
          nödvändigt.
        </p>

        <p className="mt-10">
          Om det krävs för att klargöra olaglig användning eller missbruk av
          plattformen, eller för åtal, kommer personuppgifter att
          vidarebefordras till brottsbekämpande organ eller andra myndigheter
          och, i förekommande fall, till skadelidande tredje parter. Detta ska
          dock endast ske om det finns tecken på olagligt eller kränkande
          beteende. Vi är även juridiskt skyldiga att på begäran tillhandahålla
          information till vissa offentliga organ. Dessa är brottsbekämpande
          myndigheter, myndigheter som åtalar administrativa överträdelser som
          kan bestraffas med böter och skattemyndigheter.
        </p>

        <p className="mt-10">
          Varje utlämnande av personuppgifter motiveras av det faktum att (1)
          behandlingen är nödvändig för att uppfylla en rättslig skyldighet som
          vi är föremål för enligt art. 6 (1) (c) GDPR i kombination med
          nationella rättsliga krav för utlämnande av uppgifter till
          brottsbekämpande myndigheter, eller (2) vi har ett legitimt intresse
          av att avslöja uppgifterna till ovannämnda tredje parter om det finns
          tecken på missbruk eller för att driva igenom rättsliga anspråk och
          dina rättigheter och intressen i skyddet av dina personuppgifter i den
          mening som avses i art. 6 (1) (f) GDPR inte uppväger vårt legitima
          intresse.
        </p>

        <p className="mt-10">
          Tredjepartsföretag och externa tjänsteleverantörer används för att vi
          ska kunna erbjuda tjänsterna på denna plattform. Alla
          tredjepartsföretag och externa tjänsteleverantörer som används väljs
          noggrant ut som registerförare inom ramen för art. 28 (1) GDPR,
          kontrolleras regelbundet och är avtalsenligt skyldiga att behandla
          alla personuppgifter uteslutande i enlighet med våra instruktioner.
        </p>
      </div>

      <div className="mt-40">
        <h2>VI. Överföring av uppgifter till tredjeländer</h2>

        <p>
          Om inget annat anges överförs uppgifter till organ i länder utanför
          Europeiska unionen (s.k. tredjeländer) endast om
        </p>

        <ul>
          <li>
            det är nödvändigt för utförandet av dina uppmaningar (t.ex.
            betalningsuppdrag),
          </li>
          <li>en adekvat nivå av dataskydd säkerställs, eller</li>
          <li>du har gett oss ditt samtycke.</li>
        </ul>
      </div>

      <div className="mt-40">
        <h2>VII. Datasäkerhet</h2>

        <h3>1. Allmänna tekniska och organisatoriska åtgärder:</h3>
        <p>
          Kärcher har vidtagit en rad säkerhetsåtgärder för att skydda
          personuppgifter på lämpligt och adekvat sätt. Alla uppgifter som
          lagras av Kärcher skyddas av fysiska, tekniska och processuella
          åtgärder som begränsar tillgången till uppgifterna till särskilt
          behöriga personer i enlighet med denna dataskyddspolicy.
        </p>

        <h3>2. Säker dataöverföring</h3>
        <p>
          Överföringen av dina personuppgifter i samband med en
          beställningsprocess krypteras med hjälp av branschstandarden Secure
          Socket Layer (&quot;SSL&quot;) -teknik, SSL-krypteringsversion.
        </p>

        <h3>3. Lösenord</h3>
        <p>
          Du bör aldrig lämna ut ditt lösenord till tredje parter för åtkomst
          till våra Professional-portaler/lösningar och du bör vidare
          regelbundet ändra det. Om du vill avsluta ditt användarkonto bör du
          logga ut och stänga din webbläsare för att undvika att någon obehörig
          får åtkomst till det.
        </p>
      </div>

      <div className="mt-40">
        <h2>VIII. Den registrerades rättigheter</h2>

        <h3>1. Rätt till tillgång</h3>
        <p>
          I enlighet med art. 15 GDPR kan du begära tillgång till dina
          personuppgifter som vi behandlar.
        </p>

        <h3>2. Rätt till rättelse:</h3>
        <p>
          Om informationen om dig inte är (eller inte längre är) korrekt kan du
          begära rättelse enligt art. 16 GDPR. Om dina uppgifter är
          ofullständiga kan du begära att uppgifterna kompletteras.
        </p>

        <h3>3. Rätt till radering:</h3>
        <p>
          Du kan begära radering av dina personuppgifter i enlighet med artikel
          17 GDPR.
        </p>

        <h3>4. Rätt till begränsning av behandlingen:</h3>
        <p>
          I enlighet med art. 18 i GDPR har du rätt att begära en begränsning av
          behandlingen av dina personuppgifter.
        </p>

        <h3>5. Rätt att lämna in ett klagomål:</h3>
        <p>
          Om du anser att behandlingen av dina personuppgifter strider mot
          dataskyddslagstiftningen har du rätt att lämna in ett klagomål till en
          dataskyddsmyndighet som du själv väljer, eller till den
          dataskyddsmyndighet som ansvarar för den personuppgiftsansvariga i
          enlighet med artikel 77 (1) i GDPR.
        </p>

        <h3>6. Rätt till dataportabilitet</h3>
        <p>
          I händelse av att kraven i art. 20 (1)i GDPR uppfylls har du rätt att
          få uppgifter som vi behandlar automatiskt på grundval av ditt samtycke
          eller vid fullgörande av ett avtal överlämnade till dig eller till
          tredje part.
        </p>

        <h3>7. Rätt att göra invändningar enligt art. 21 (1) i GDPR:</h3>
        <p>
          <b>
            Du har rätt att när som helst, av skäl som rör din specifika
            situation, invända mot behandlingen av dina personuppgifter som
            utförs på grundval av artikel 6 (1) (f) GDPR. Den
            personuppgiftsansvariga upphör då med behandlingen av
            personuppgifterna såvida den personuppgiftsansvariga inte uppvisar
            avgörande berättigade skäl för behandlingen som uppväger den
            registrerades intressen, rättigheter och friheter, eller om
            behandlingen sker för att fastställa, utöva eller försvara rättsliga
            anspråk.
          </b>
        </p>
      </div>
    </>
  );
}
